import { useTranslation } from 'react-i18next'
import { Surface } from '@/components/Surface'

const APP_STORE_URL =
  'https://apps.apple.com/it/app/spiagge-it-booking-spiaggia/id1269882377'
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.anm22.yourbeach&hl=it'

export function AppDownload() {
  const { t } = useTranslation()

  return (
    <Surface
      as="article"
      className="flex w-full flex-col gap-4 p-4 text-center [&_svg]:size-7 [&_svg]:rotate-180"
    >
      <Surface.Icon iconName="MobileDevice" />

      <div>
        <h3 className="mb-1 font-bold">{t('thankYou.appDownload.title')}</h3>
        <p>{t('thankYou.appDownload.description')}</p>
      </div>

      <div className="flex justify-center gap-4">
        <a href={APP_STORE_URL} rel="noopener noreferrer" target="_blank">
          <img
            alt={t('thankYou.appDownload.appStore')}
            height="40"
            src="https://img.spiagge.it/media/spiagge/App-Store-Badge.svg"
            width="135"
          />
        </a>

        <a href={PLAY_STORE_URL} rel="noopener noreferrer" target="_blank">
          <img
            alt={t('thankYou.appDownload.googlePlay')}
            height="40"
            src="https://img.spiagge.it/media/spiagge/Google-Play-Badge.svg"
            width="135"
          />
        </a>
      </div>
    </Surface>
  )
}
